class PredictiveSearch {
  constructor(root) {
    this.input = root.querySelector('input[type="search"]');
    this.form = root.querySelector('.header__search--form');
    this.predictiveSearchResults = root.querySelector("#predictive-search");
    this.overlay = document.querySelector(".canvas-overlay");
    this.pendingRequest = null;

    this.form.addEventListener("submit", this.onSubmit.bind(this));
    this.input.addEventListener("input", this.onChange.bind(this));
    this.input.addEventListener("focus", this.onfocus.bind(this));
    this.overlay.addEventListener("click", this.onOverlay.bind(this));
  }


  onSubmit(event) {
    if(this.input.value == "") {
      event.preventDefault()
    }
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.pendingRequest = null;

      if (window.innerWidth >= 768) {
        this.close();
      }

      return;
    }

    this.getSearchResults(searchTerm);
  }

  onOverlay() {
    this.close();
  }

  onfocus() {
    const searchTerm = this.input.value.trim();
    this.predictiveSearchResults.parentElement.classList.add("open");

    if (window.innerWidth < 768) {
      this.overlay.classList.add("active");
    }

    if (searchTerm.length) {
      this.open();
      this.input.select();
    }
  }

  getSearchResults(searchTerm) {
    this.pendingRequest = searchTerm;

    fetch(
      `/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[options][fields]=title,product_type,tag,vendor,variants.sku,variants.barcode,body&resources[limit]=4&resources[limit_scope]=each&resources[type]=product,query,collection`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        if (this.pendingRequest === searchTerm) {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#shopify-section-predictive-search").innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
        }
      })
      .catch((error) => {
        if (this.pendingRequest === searchTerm) {
          this.close();
          throw error;
        }
      });
  }

  open() {
    this.predictiveSearchResults.style.display = "block";
    this.predictiveSearchResults.parentElement.classList.add("open");
    this.overlay.classList.add("active");
  }

  close() {
    this.predictiveSearchResults.style.display = "none";
    this.predictiveSearchResults.parentElement.classList.remove("open");
    this.overlay.classList.remove("active");
  }
}

new PredictiveSearch(document.querySelector(".header__search"));
